import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import moment from 'moment';
import { RctCard, RctCardContent } from 'Components/RctCard';

import { 
    fetchPlayerSamLab,
    fetchPlayerCaptoLab,
    fetchPlayerlaunch,
    fetchPlayerFsIron,
    fetchPlayerFsDriver,
    fetchPlayerWedge,
    fetchPlayerhack,
    fetchPlayerSpeed,
    fetchPlayerIntervention,
 } from 'Actions';

 
 import SamItem from '../../../../golf/playerintervention/component/technology/samdata';
 import CaptoItem from '../../../../golf/playerintervention/component/technology/captodata';
 import LaunchItem from '../../../../golf/playerintervention/component/technology/launchdata';
 import HackItem from '../../../../golf/playerintervention/component/technology/hackdata';
 import IronItem from '../../../../golf/playerintervention/component/technology/fsirondata';
 import DriverItem from '../../../../golf/playerintervention/component/technology/fsdriverdata';
 import WedgeItem from '../../../../golf/playerintervention/component/technology/wedgedata';
 import SpeedItem from '../../../../golf/playerintervention/component/technology/speeddata';
 import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
 import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
 import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';

class GolfTechnology extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    UNSAFE_componentWillMount() {
        
	}
    constructor(props) {
      
        super(props);
        let startDate = new Date();
        let befrstart=new Date(startDate.setMonth(startDate.getMonth() - 2));
        this.state = {  
            student:this.props.data.student, 
            startdate:'',
            enddate:'',
            loader:false,
            maindiv:true,
            viewsam:false,
            viewcapto:false,
            viewlaunch:false,
            viewhack:false,
            viewspeed:false,
            viewiron:false,
            viewdriver:false,
            viewwedge:false,
            frmreport:2,
        };

        this.onBackSection = this.onBackSection.bind(this);
    }

    rangeSelection(id){
        var student=this.state.student;
        var stdate=this.state.startdate;
        var eddate=this.state.enddate;
                          
            if(id==1){
                this.props.fetchPlayerSamLab(student, stdate, eddate).then((data) => { 
                    this.setState({ 
                        maindiv:false, 
                        viewsam:true,                                      
                    });        
                });
                
            }else if(id==2){
                this.props.fetchPlayerCaptoLab(student, stdate, eddate).then((data) => { 
                    this.setState({ 
                        maindiv:false,
                        viewcapto:true,                                      
                    });        
                });
            }else if(id==3){
                this.props.fetchPlayerlaunch(student, stdate, eddate).then((data) => { 
                    this.setState({ 
                        maindiv:false,
                        viewlaunch:true,                                      
                    });        
                });
            }else if(id==4){
                this.props.fetchPlayerFsIron(student, stdate, eddate).then((data) => { 
                    this.setState({ 
                        maindiv:false,
                        viewiron:true,                                      
                    });        
                }); 
            }else if(id==5){
                this.props.fetchPlayerFsDriver(student, stdate, eddate).then((data) => { 
                    this.setState({ 
                        maindiv:false,
                        viewdriver:true,                                      
                    });        
                }); 
            }else if(id==6){
                this.props.fetchPlayerWedge(student, stdate, eddate).then((data) => { 
                    this.setState({ 
                        maindiv:false,
                        viewwedge:true,                                      
                    });        
                });            
            }else if(id==7){
                this.props.fetchPlayerhack(student, stdate, eddate).then((data) => { 
                    this.setState({ 
                        maindiv:false,
                        viewhack:true,                                      
                    });        
                });
            }else if(id==8){
                this.props.fetchPlayerSpeed(student, stdate, eddate).then((data) => { 
                    this.setState({ 
                        maindiv:false,
                        viewspeed:true,                                      
                    });        
                });
            }
        
    }

    onBackSection() {		
        var student=this.state.student;
        var stdate='';
        var eddate='';
        this.props.fetchPlayerIntervention(student, stdate, eddate).then((data) => {
            this.setState({
                viewsam:false,
                viewcapto:false,
                viewlaunch:false,
                viewhack:false,
                viewspeed:false,
                viewiron:false,
                viewdriver:false,
                viewwedge:false,
                maindiv:true,
            });
        });
	}


render() {

    const { playerinterventionlist, loading} = this.props;   
    

      return(
        <div>   
                {this.state.maindiv && 
                <>
                <div className="row" style={{marginBottom:"20px"}}>
                    <div className="col-lg-2"><div className="float-left"><button className="mr-3 mb-3 btn btn-info btn-sm float-left" onClick={() => this.props.onClick()}><HomeOutlinedIcon aria-hidden="true" /> Main</button></div></div>
                    <div className="col-lg-8"><h2 className="text-center">TECHNOLOGY REPORTS</h2></div>
                    <div className="col-lg-2"><div className="float-right"><button className="mr-3 mb-3 btn btn-outline-warning btn-sm float-right" onClick={() => this.props.onClick1(1)}><KeyboardDoubleArrowLeftIcon aria-hidden="true" /> Back</button></div></div>
                </div>
                <div className="row">
                     
                    <div className="col-sm-6 col-md-4 col-lg-4 w-xs-half-block">
                        <a onClick={ ()=>this.rangeSelection(1)} > 
                        <div className="social-card">
                            <span className="rounded-circle social-icon twitter"><AssessmentOutlinedIcon aria-hidden="true" fontSize="inherit" /></span>
                            <div>
                                <h1 className="text-center">{playerinterventionlist.technology.sam}</h1>
                                <h2 className="text-center">SAM LAB REPORTS</h2>
                            </div>
                        </div> 
                        </a>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-4 w-xs-half-block">
                        <a onClick={ ()=>this.rangeSelection(2)} > 
                        <div className="social-card">
                            <span className="rounded-circle social-icon google"><AssessmentOutlinedIcon aria-hidden="true" fontSize="inherit" /></span>
                            <div>
                                <h1 className="text-center">{playerinterventionlist.technology.capto}</h1>
                                <h2 className="text-center">CAPTO REPORTS</h2>
                            </div>
                        </div> 
                        </a>
                    </div> 
                    <div className="col-sm-6 col-md-4 col-lg-4 w-xs-half-block">
                        <a onClick={ ()=>this.rangeSelection(3)} >  
                        <div className="social-card">
                            <span className="rounded-circle social-icon linkedin"><AssessmentOutlinedIcon aria-hidden="true" fontSize="inherit" /></span>
                            <div>
                                <h1 className="text-center">{playerinterventionlist.technology.launch}</h1>
                                <h2 className="text-center">LAUNCH MONITOR REPORTS</h2>
                            </div>
                        </div> 
                        </a>
                    </div> 
                    <div className="col-sm-6 col-md-4 col-lg-4 w-xs-half-block">
                            <a onClick={ ()=>this.rangeSelection(4)} > 
                        <div className="social-card">
                            <span className="rounded-circle social-icon google"><AssessmentOutlinedIcon aria-hidden="true" fontSize="inherit" /></span>
                            <div>
                                <h1 className="text-center">{playerinterventionlist.technology.iron}</h1>
                                <h2 className="text-center">QUARTERLY IRONS REPORTS</h2>
                            </div>
                        </div>
                        </a> 
                    </div> 
                    <div className="col-sm-6 col-md-4 col-lg-4 w-xs-half-block">
                        <a onClick={ ()=>this.rangeSelection(5)} > 
                        <div className="social-card">
                            <span className="rounded-circle social-icon google"><AssessmentOutlinedIcon aria-hidden="true" fontSize="inherit" /></span>
                            <div>
                                <h1 className="text-center">{playerinterventionlist.technology.driver}</h1>
                                <h2 className="text-center">QUARTERLY DRIVER REPORT</h2>
                            </div>
                        </div> 
                        </a>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-4 w-xs-half-block">
                        <a onClick={ ()=>this.rangeSelection(6)} > 
                        <div className="social-card">
                            <span className="rounded-circle social-icon google"><AssessmentOutlinedIcon aria-hidden="true" fontSize="inherit" /></span>
                            <div>
                                <h1 className="text-center">{playerinterventionlist.technology.wedgeplay}</h1>
                                <h2 className="text-center">QUARTERLY WEDGEPLAY REPORTS</h2>
                            </div>
                        </div> 
                        </a>
                    </div> 
                    <div className="col-sm-6 col-md-4 col-lg-4 w-xs-half-block">
                        <a onClick={ ()=>this.rangeSelection(7)} > 
                        <div className="social-card">
                            <span className="rounded-circle social-icon linkedin"><AssessmentOutlinedIcon aria-hidden="true" fontSize="inherit" /></span>
                            <div>
                                <h1 className="text-center">{playerinterventionlist.technology.hack}</h1>
                                <h2 className="text-center">HACK MOTION REPORTS</h2>
                            </div>
                        </div>
                        </a> 
                    </div> 
                    <div className="col-sm-6 col-md-4 col-lg-4 w-xs-half-block">
                        <a onClick={ ()=>this.rangeSelection(8)} > 
                        <div className="social-card">
                            <span className="rounded-circle social-icon google"><AssessmentOutlinedIcon aria-hidden="true" fontSize="inherit" /></span>
                            <div>
                                <h1 className="text-center">{playerinterventionlist.technology.speed}</h1>
                                <h2 className="text-center">MONTHLY SPEED CHECK</h2>
                            </div>
                        </div>
                        </a> 
                    </div>      
                    
                </div>  
            </>        
            } 
            
            {this.state.viewsam &&
                   
                   <SamItem data={this.state} onClick={this.onBackSection} />
               }

               {this.state.viewcapto &&
              
                   <CaptoItem data={this.state} onClick={this.onBackSection} />
               }

               {this.state.viewlaunch &&
              
                   <LaunchItem data={this.state} onClick={this.onBackSection} />
               }

               {this.state.viewiron &&
              
                   <IronItem data={this.state} onClick={this.onBackSection} />
               }

               {this.state.viewdriver &&
              
                   <DriverItem data={this.state} onClick={this.onBackSection} />
               }

               {this.state.viewwedge &&
              
                   <WedgeItem data={this.state} onClick={this.onBackSection} />
               }

               {this.state.viewhack &&
              
                   <HackItem data={this.state} onClick={this.onBackSection} />
               }

               {this.state.viewspeed &&
              
                   <SpeedItem data={this.state} onClick={this.onBackSection} />
               }

        </div>
              
    )
   
}
 
}

const mapStateToProps = ({ playerintervention }) => {
    const { playerinterventionlist, loading } = playerintervention;
    return { playerinterventionlist, loading };
   
}


export default connect(mapStateToProps, {
    fetchPlayerSamLab,
    fetchPlayerCaptoLab,
    fetchPlayerlaunch,
    fetchPlayerFsIron,
    fetchPlayerFsDriver,
    fetchPlayerWedge,
    fetchPlayerhack,
    fetchPlayerSpeed,
    fetchPlayerIntervention
})(GolfTechnology);
